/* ONX Customs v4 — CRO-optimised Theme JS */
(function(){
'use strict';

/* ── CART ENGINE ──────────────────────────────── */
var Cart={
  thresh:(window.ONX&&window.ONX.thresh||150)*100,
  init:function(){
    var s=this;
    s.drawer=document.getElementById('cdw');
    s.overlay=document.getElementById('cov');
    s.itemsEl=document.getElementById('citems');
    s.totalEl=document.getElementById('ctotal');
    s.fillEl=document.getElementById('shipfill');
    s.shipTxt=document.getElementById('shiptxt');
    // Open triggers
    document.querySelectorAll('[data-oc]').forEach(function(b){b.addEventListener('click',function(){s.open()})});
    var cl=document.getElementById('cdw-close');
    if(cl)cl.addEventListener('click',function(){s.close()});
    if(s.overlay)s.overlay.addEventListener('click',function(){s.close()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')s.close()});
    document.addEventListener('cart:refresh',function(){s.refresh()});
    // Init count
    s.fetchCount();
  },
  fetchCount:function(){
    var s=this;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){s.updateCount(c.item_count)}).catch(function(){});
  },
  open:function(){
    if(this.drawer)this.drawer.classList.add('open');
    if(this.overlay)this.overlay.classList.add('open');
    document.body.style.overflow='hidden';
    var tt=document.getElementById('atc-toast');if(tt)tt.classList.remove('show');
    this.refresh();
  },
  close:function(){
    if(this.drawer)this.drawer.classList.remove('open');
    if(this.overlay)this.overlay.classList.remove('open');
    document.body.style.overflow='';
  },
  refresh:function(){
    var s=this;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      s.updateCount(c.item_count);
      s.updateShip(c.total_price);
      s.renderItems(c.items);
      s.updateTotal(c.total_price);
      s.toggleFooter(c.item_count);
    }).catch(function(e){console.warn('Cart refresh failed',e)});
  },
  toggleFooter:function(n){
    var show=n>0?'':'none';
    var ftr=document.querySelector('.cdw__ftr');
    var ups=document.querySelector('.cdw__upsell');
    if(ftr)ftr.style.display=show;
    if(ups)ups.style.display=show;
  },
  updateCount:function(n){
    document.querySelectorAll('[data-cc]').forEach(function(el){
      el.textContent=n;
      // Only the round header badge toggles visibility; inline title counts stay inline
      if(el.classList.contains('cbadge'))el.style.display=n>0?'flex':'none';
    });
  },
  updateShip:function(cents){
    var aunz=window.ONX&&window.ONX.aunz;
    if(this.shipTxt){
      if(!aunz){this.shipTxt.innerHTML='Shipping calculated at checkout';}
      else{
        var rem=this.thresh-cents;
        if(rem<=0){this.shipTxt.innerHTML='<strong>You\'ve unlocked FREE shipping! 🎉</strong>';}
        else{this.shipTxt.innerHTML='You\'re <strong>'+this.fmt(rem)+'</strong> away from free shipping 🇦🇺';}
      }
    }
    if(this.fillEl){this.fillEl.style.width=aunz?Math.min(100,cents/this.thresh*100)+'%':'0%';}
    this.updateNote(cents,aunz);
  },
  updateNote:function(cents,aunz){
    var note=document.getElementById('cdw-shipnote');
    if(!note)return;
    if(!aunz){note.innerHTML='+ shipping &amp; taxes calculated at checkout';note.style.color='var(--muted)';return;}
    var rem=this.thresh-cents;
    if(rem>0){note.innerHTML='Add '+this.fmt(rem)+' more for FREE shipping 🇦🇺';note.style.color='var(--accent)';}
    else{note.innerHTML='✓ FREE shipping unlocked — AUS &amp; NZ';note.style.color='#16a34a';}
  },
  updateTotal:function(c){if(this.totalEl)this.totalEl.textContent=this.fmt(c);var co=document.getElementById('co-amt');if(co)co.textContent=this.fmt(c);},
  renderItems:function(items){
    if(!this.itemsEl)return;
    if(!items.length){
      this.itemsEl.innerHTML='<div style="text-align:center;padding:52px 16px"><p style="font-family:var(--head);font-weight:900;font-size:19px;text-transform:uppercase;margin-bottom:8px">Your cart is empty</p><p style="font-size:14px;color:var(--muted);margin-bottom:24px">Find parts engineered for your bike.</p><a href="/collections/all" class="btn btn--dk btn--sm" onclick="Cart.close()">Shop All Parts</a></div>';
      return;
    }
    this.itemsEl.innerHTML=items.map(function(it){
      var saveLine='';
      if(it.compare_at_price&&it.compare_at_price>it.price){
        var sav=it.compare_at_price-it.price;
        if(sav>0)saveLine='<div style="font-size:10px;color:var(--accent);font-family:var(--head);font-weight:700;letter-spacing:.06em;text-transform:uppercase;margin-top:2px">Save '+Cart.fmt(sav)+'</div>';
      }
      return '<div class="ci" data-key="'+it.key+'"><img class="ci__img" src="'+it.image+'" alt="'+it.product_title+'" loading="lazy"><div><div class="ci__name">'+it.product_title+'</div>'+(it.variant_title&&it.variant_title!=='Default Title'?'<div class="ci__var">'+it.variant_title+'</div>':'')+saveLine+'<div class="ci__row"><div class="qc"><button class="qb" data-a="dec" data-key="'+it.key+'" data-q="'+it.quantity+'">−</button><span class="qn">'+it.quantity+'</span><button class="qb" data-a="inc" data-key="'+it.key+'" data-q="'+it.quantity+'">+</button><button class="qb" data-a="rm" data-key="'+it.key+'" style="margin-left:4px;font-size:11px">✕</button></div><span class="ci__price">'+Cart.fmt(it.final_line_price)+'</span></div></div></div>';
    }.bind(this)).join('');
    var s=this;
    this.itemsEl.querySelectorAll('[data-a]').forEach(function(b){
      b.addEventListener('click',function(){
        var a=b.dataset.a,k=b.dataset.key,q=parseInt(b.dataset.q);
        if(a==='inc')s.changeQty(k,q+1);
        if(a==='dec')s.changeQty(k,Math.max(0,q-1));
        if(a==='rm')s.changeQty(k,0);
      });
    });
  },
  changeQty:function(key,qty){
    var s=this;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(){s.refresh();}).catch(function(){});
  },
  fmt:function(c){return'$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
};

/* ── ADD TO CART ──────────────────────────────── */
var ATC={
  init:function(){
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-atc]');
      if(!btn)return;
      e.preventDefault();
      ATC.add(btn);
    });
    var form=document.getElementById('pform');
    if(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var b=form.querySelector('[data-atc]');
        if(b)ATC.add(b);
      });
    }
  },
  add:function(btn){
    // Get id from button data-id or from hidden form input
    var id=btn.dataset.id;
    if(!id){
      var form=btn.closest('form')||document.getElementById('pform');
      var inp=form&&form.querySelector('[name="id"]');
      id=inp&&inp.value;
    }
    if(!id)return;
    var orig=btn.innerHTML;
    btn.disabled=true;
    btn.innerHTML='<span style="opacity:.6">Adding...</span>';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:parseInt(id),quantity:1})
    }).then(function(r){
      if(!r.ok)throw new Error('OOS');
      btn.innerHTML='✓ Added';
      document.dispatchEvent(new CustomEvent('cart:refresh')); // update badge + drawer contents without opening
      Toast.show();
      setTimeout(function(){btn.innerHTML=orig;btn.disabled=false;},2400);
    }).catch(function(e){
      btn.innerHTML=e.message==='OOS'?'Out of Stock':'Error — try again';
      setTimeout(function(){btn.innerHTML=orig;btn.disabled=false;},2400);
    });
  }
};

/* ── ADD-TO-CART TOAST ────────────────────────── */
var Toast={
  el:null,_t:null,
  init:function(){ this.el=document.getElementById('atc-toast'); },
  show:function(){
    if(!this.el)this.el=document.getElementById('atc-toast');
    if(!this.el)return;
    var el=this.el;
    el.classList.add('show');
    clearTimeout(this._t);
    this._t=setTimeout(function(){ el.classList.remove('show'); },2800);
  }
};

/* ── MOBILE NAV ───────────────────────────────── */
var MNav={
  nav:null,
  open:function(){
    if(!this.nav)return;
    // Span the full screen height (top:0 + bottom:0 avoids dvh/vh gaps on mobile)
    this.nav.style.top='0';
    this.nav.style.bottom='0';
    this.nav.style.height='auto';
    var ov=document.getElementById('mnav-ov');
    if(ov){ov.style.top='0';ov.classList.add('open');}
    this.nav.classList.add('open');
    document.body.style.overflow='hidden';
  },
  close:function(){
    if(!this.nav)return;
    this.nav.classList.remove('open');
    this.nav.style.top='';
    this.nav.style.bottom='';
    this.nav.style.height='';
    var ov=document.getElementById('mnav-ov');
    if(ov){ov.classList.remove('open');ov.style.top='';}
    document.body.style.overflow='';
  },
  init:function(){
    var self=this;
    self.nav=document.getElementById('mnav');
    var tog=document.getElementById('mbtn');
    var cls=document.getElementById('mnav-close');
    var ov=document.getElementById('mnav-ov');
    if(tog)tog.addEventListener('click',function(e){e.stopPropagation();self.open();});
    if(cls)cls.addEventListener('click',function(){self.close();});
    var pull=document.getElementById('mnav-pull-close');
    if(pull)pull.addEventListener('click',function(){self.close();});
    if(ov)ov.addEventListener('click',function(){self.close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')self.close();});
    if(self.nav){
      var sx=0;
      self.nav.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
      self.nav.addEventListener('touchend',function(e){
        if(e.changedTouches[0].clientX-sx<-50)self.close();
      },{passive:true});
      var links=self.nav.querySelector('.mnav__links');
      if(links){
        links.addEventListener('touchstart',function(e){e.stopPropagation();},{passive:true});
        links.addEventListener('touchmove',function(e){e.stopPropagation();},{passive:true});
      }
    }
  }
};

/* ── SCROLL REVEAL ────────────────────────────── */
var Reveal={
  init:function(){
    if(!('IntersectionObserver' in window)){
      document.querySelectorAll('.rv-anim').forEach(function(e){e.classList.add('vis')});
      return;
    }
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}});
    },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
    document.querySelectorAll('.rv-anim').forEach(function(el){obs.observe(el);});
  }
};

/* ── DRAG SCROLL (reviews carousel) ──────────── */
function dragScroll(el){
  if(!el)return;
  var down=false,sx,sl;
  el.addEventListener('mousedown',function(e){down=true;el.style.cursor='grabbing';sx=e.pageX-el.offsetLeft;sl=el.scrollLeft;});
  el.addEventListener('mouseleave',function(){down=false;el.style.cursor='grab';});
  el.addEventListener('mouseup',function(){down=false;el.style.cursor='grab';});
  el.addEventListener('mousemove',function(e){if(!down)return;e.preventDefault();el.scrollLeft=sl-(e.pageX-el.offsetLeft-sx)*1.4;});
}

/* ── INIT ─────────────────────────────────────── */
document.addEventListener('DOMContentLoaded',function(){
  Cart.init();
  ATC.init();
  Toast.init();
  MNav.init();
  Reveal.init();
  document.querySelectorAll('.rv-scroll').forEach(dragScroll);
});

/* Expose Cart.close for inline onclick in empty cart state */
window.Cart=Cart;

})();
